// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2wvKS","buttons":"PendingPaymentAlert_buttons__3Q_T_"};